/** Tailwind `sm` breakpoint – schmale Viewports inkl. Mobilgeräte. */
export const MOBILE_VIEWPORT_MAX_WIDTH_PX = 639;

/** iPhone/iPad/iPod inkl. iPadOS mit Desktop-UA. */
export function isIosTouchDevice(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

export function isMobileViewport(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia(`(max-width: ${MOBILE_VIEWPORT_MAX_WIDTH_PX}px)`).matches;
}
